<script lang="ts">
  import PrivacySelector from './PrivacySelector.svelte'
  import PrivacyPreview from './PrivacyPreview.svelte'

  let { value = 'full_disclosure', currentUser = {} as Record<string, any>, onChange = (_v: string) => {}, disabled = false }: {
    value?: string
    currentUser?: Record<string, any>
    onChange?: (value: string) => void
    disabled?: boolean
  } = $props()

  function handleChange(newValue: string) {
    onChange(newValue)
  }
</script>

<div class="privacy-selector-with-preview">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <!-- 좌측: 공개 범위 선택 -->
    <div class="flex flex-col">
      <PrivacySelector
        {value}
        onChange={handleChange}
        {disabled}
      />
    </div>

    <!-- 우측: 실시간 미리보기 -->
    <div class="flex flex-col">
      <PrivacyPreview
        privacy={value}
        {currentUser}
      />
    </div>
  </div>
</div>

<style>
  .privacy-selector-with-preview {
    width: 100%;
  }

  @media (max-width: 1024px) {
    .privacy-selector-with-preview {
      display: block;
    }
  }
</style>
